import { Skeleton } from '@/shared/components/ui/skeleton';

export function TimelineLoading() {
  return (
    <div data-testid="tasks-timeline-loading" className="flex h-full flex-col gap-2 p-4">
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton key={index} className="h-14 w-full" />
      ))}
    </div>
  );
}
